import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
export default {
  components: {
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      slides: [{
        name: "游戏类广告",
        content: '聚合多家广告联盟SDK，独家内容资源提升用户留存，打破"即用即走"魔咒，节假日收益走高明显。',
        addper: "80%"
      }, {
        name: "视频影音类广告",
        content: "AdJM针对视频类APP具有多方面的收益优势，包括广告填充率、多样化的广告形式",
        addper: "70%"
      }, {
        name: "系统工具类广告",
        content: '聚合多家广告联盟SDK，独家内容资源提升用户留存，打破"即用即走"魔咒，节假日收益走高明显。',
        addper: "80%"
      }],
      swiperOptions: {
        // 自动播放
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        pauseOnMouseEnter: true,
        // 循环模式
        loop: true,
        // 前进后退按钮
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      isHover: false
    };
  },
  methods: {
    getImagePath(index) {
      return require(`../../assets/images/class-${index + 1}.jpg`);
    },
    mouseEnter() {
      this.isHover = true;
    },
    mouseLeave() {
      this.isHover = false;
    }
  }
};